/* eslint-disable indent */
import React, { useEffect, useState } from 'react';
import SearchRegistrationIdSubUserForm from '../../components/forms/SearchRegistrationIdSubUserForm';
import { searchSubUserByRegistrationId, clearMessage, editStatusBySubUserId, resetState } from './actions';
import { useDispatch, useSelector } from 'react-redux';
import GridCell from '../../components/elements/GridCell';
import IconStore from '../../components/icons/IconStore';
import { Modal, CloseButton, Switch, Grid, Flex, SimpleGrid, Loader } from '@mantine/core';
import Button from '../../components/elements/Button';
import styles from './styles.scoped.css';

export function FormByRegistrationId() {
  const dispatch = useDispatch();
  const {
    dataSubMerchantActivationSearch,
    isLoadingSubMerchantActivationSearch,
    messageSubMerchantActivationSearch,
    dataEditStatusBySubUserId,
  } = useSelector((s) => s.subMerchantActivation);
  const [modalAct, setModalAct] = useState('');
  const gridProps = { left: 4, right: 8 };
  const gridData = [
    {
      data: dataSubMerchantActivationSearch?.registrationId,
      label: 'ID Pangkalan',
      ...gridProps,
    },
    {
      data: dataSubMerchantActivationSearch?.registrationDate,
      label: 'Tanggal Registrasi',
      ...gridProps,
    },
    {
      data: dataSubMerchantActivationSearch?.registrationTime,
      label: 'Jam Registrasi',
      ...gridProps,
    },
  ];
  const modalWords = {
    1: { subtitle: 'menonaktifkan', title: 'Nonaktifkan' },
    0: { subtitle: 'mengaktifkan', title: 'Aktifkan' },
  };

  const handleSearch = (val) => {
    return dispatch(searchSubUserByRegistrationId(val.registrationId));
  };
  const handleSubmit = (values) => {
    handleClose();
    const switchStatus = values.isRegisterSubPangkalan ? 0 : 1;
    return dispatch(editStatusBySubUserId({ ...values, isRegisterSubPangkalan: switchStatus }));
  };
  const handleReset = (key) => {
    return dispatch(clearMessage(key));
  };
  const handleModal = (key) => {
    setModalAct(key);
  };
  const handleClose = () => {
    setModalAct('');
  };

  useEffect(() => {
    if (dataEditStatusBySubUserId) {
      handleClose();
      handleSearch(dataSubMerchantActivationSearch);
    }
  }, [dataEditStatusBySubUserId]);

  useEffect(() => {
    return () => {
      dispatch(resetState('SubMerchantActivationSearch'));
    };
  }, []);

  return (
    <>
      <SearchRegistrationIdSubUserForm
        buttonLabel="Cari Pangkalan"
        handleReset={() => handleReset('SearchSubUserByRegistrationId')}
        handleSubmit={handleSearch}
        label="ID Pangkalan"
        message={messageSubMerchantActivationSearch}
      />
      {isLoadingSubMerchantActivationSearch && (
        <Flex align="center" justify="center" mb={'4rem'} mt={'5.5rem'}>
          <Loader size="lg" variant="dots" />
        </Flex>
      )}
      {Object.keys(dataSubMerchantActivationSearch).length > 0 &&
        !isLoadingSubMerchantActivationSearch && (
          <div style={{ marginTop: '1.5rem' }}>
            <span>
              Menampilkan data berdasarkan pencarian <strong>"ID Pangkalan"</strong>
            </span>
            <div className={styles['sub-user-container']}>
              <div className={styles['sub-user-header']}>
                <IconStore />
                <span>{dataSubMerchantActivationSearch?.name}</span>
              </div>
              <div className={styles['sub-user-content']}>
                {gridData.map((item, i) => (
                  <GridCell key={i} {...item} />
                ))}
              </div>
              <hr className={styles.separator} style={{ margin: 0 }} />
              <Grid>
                <Grid.Col fw={500} span={4}>Status</Grid.Col>
                <Grid.Col span={8}>
                  <Flex gap="sm">
                    :{' '}
                    <Switch
                      checked={!!dataSubMerchantActivationSearch?.isRegisterSubPangkalan}
                      color="green"
                      offLabel="Tidak Aktif"
                      onClick={(e) => {
                        e.preventDefault();
                        handleModal('edit-status');
                      }}
                      onLabel="Aktif"
                      size="lg"
                      styles={{
                        track: {
                          backgroundColor: '#CF212A',
                          color: 'white',
                        },
                      }}
                    />
                  </Flex>
                </Grid.Col>
              </Grid>
            </div>
          </div>
        )}
      <Modal
        centered
        isLoading
        onClose={() => setModalAct('')}
        opened={modalAct === 'edit-status'}
        size={'lg'}
        withCloseButton={false}
      >
        <div className={styles['modal-container']}>
          <div className={styles['modal-header']}>
            <h5>{`${modalWords[dataSubMerchantActivationSearch?.isRegisterSubPangkalan]?.['title']} Aktivasi Pangkalan`}</h5>
            <span onClick={handleClose}>
              <CloseButton />
            </span>
          </div>
          <span>
            Apakah Anda yakin ingin{' '}
            {modalWords[dataSubMerchantActivationSearch?.isRegisterSubPangkalan]?.['subtitle']}{' '}
            Aktivasi Fitur Pendaftaran Subpangkalan pada Pangkalan dengan ID Pangkalan{' '}
            <strong>{dataSubMerchantActivationSearch?.registrationId}</strong>?
          </span>
          <SimpleGrid cols={2} gap="sm" mt={'md'}>
            <Button className={styles['btn-modal-status']} onClick={handleClose} style="outlined">
              Batal
            </Button>
            <Button
              className={styles['btn-modal-status']}
              onClick={() => handleSubmit(dataSubMerchantActivationSearch)}
            >
              {modalWords[dataSubMerchantActivationSearch?.isRegisterSubPangkalan]?.['title']}
            </Button>
          </SimpleGrid>
        </div>
      </Modal>
    </>
  );
}
